import usePageTitle from '@hooks/usePageTitle/usePageTitle';
import { usePageContext } from '@providers/PageMetaProvider/model/PageContext';
import { useEffect } from 'react';
import SettingsChangePasswordForm from '@features/settings-change-password/containers/SettingsChangePasswordForm';

const pageValues = {
  title: 'Password',
  description: 'Update your password here',
};

function SettingsChangePasswordPage() {
  usePageTitle('ZlaytAI - Change Password');
  const { setValues } = usePageContext();

  useEffect(() => {
    if (setValues) {
      setValues((prev) => ({
        ...prev,
        ...pageValues,
      }));
    }
  }, []);

  return <SettingsChangePasswordForm />;
}

export default SettingsChangePasswordPage;
